import {AdminRegistratorLogsState} from "./states/admin-registrator-logs.state";

export const adminRegistratorLogs = [
    AdminRegistratorLogsState
];
